import * as m from "@qpr/client-api-base/api/model";
import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import { getModel } from "backend/model/getModel";
import { IPeriod } from "backend/model/model";
import { useQuery } from "react-query";

const usePeriods = (periodLevel?: string) => {
  const ctx = useAppContext();
  return useQuery<IPeriod[]>(
    `periods-${ctx.model}-${periodLevel || ""}`,
    async () => {
      const [model] = await getModel(ctx.model || "");
      return (await m.getPeriods(model.id))
        .filter((p) => {
          if (periodLevel) {
            if (p.periodlevel === periodLevel) return true;
            return false;
          }
          return true;
        })
        .sort((a, b) => a.startdate.localeCompare(b.startdate));
    },
    {
      enabled: true,
      cacheTime: 30 * (60 * 1000),
      staleTime: 30 * (60 * 1000),
    }
  );
};

export default usePeriods;
